import * as React from 'react';
import { useDrop } from 'react-dnd';

interface TeamDropSectionProps {
  isOver?: boolean;
  onTeamDrop: (teamId: string) => void;
  children?: React.ReactNode;
}

const TeamDropSection: React.FC<TeamDropSectionProps> = ({ onTeamDrop, children }) => {
  const [{ isOver }, dropRef] = useDrop({
    accept: 'teamCard',
    drop: (item: { teamId: string }) => {
      onTeamDrop(item.teamId);
      return {};
    },
    collect: monitor => ({
      isOver: monitor.isOver()
    })
  });

  return (
    <section ref={dropRef} className={`tournamentGridModern__panel eTeamDropSection${isOver ? ' is-over' : ''}`}>
      {children}
    </section>
  );
};

export default TeamDropSection;
